import { Component, inject, OnDestroy } from '@angular/core';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'ziro-microsoft-dial-plan-management',
  templateUrl: './dial-plan-management.component.html',
  styleUrls: ['../../admin-page.scss'],
  standalone: false,
})
export class DialPlanManagementComponent implements OnDestroy {
  private _breadcrumbsService = inject(BreadcrumbsService);

  ngOnDestroy(): void {
    this._breadcrumbsService.clearBreadcrumbs();
  }
}
